import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { IntermService } from '../../../services/general/interm.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Intermv2Service } from 'app/services/general/intermv2.service';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css'],
  providers: [IntermService, Intermv2Service]
})
export class RegistroComponent implements OnInit {
  registroFm: FormGroup;
  paginaCodigo = false;
  codigoVerificacion = new FormControl('', Validators.required)
  comoSeEnteroList = []
  codigoId = null;

  constructor(private fb: FormBuilder, public int:IntermService, public intV2:Intermv2Service, public route: ActivatedRoute, private router: Router) {
    this.registroFm = this.fb.group({
      nombres: ['', [Validators.required]],
      apellidos: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      celular: ['', [Validators.required, Validators.pattern(/^\d+$/)]], // Solo permite números
      comoSeEntero: ['', Validators.required],
      codigoReferido: ['']
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async response => {
      console.log(response.idCodigo);
      if (response.idCodigo) {
        this.paginaCodigo = true;
        this.codigoId = response.idCodigo;
      } else {
        this.comoSeEnteroList = await this.intV2.comoSeEntero()
      }
      // response.idCodigo = response
    })
  }

  registrarse() {
    if(this.registroFm.valid) {
      this.int.registrase(this.registroFm.value).then(res => {
        this.router.navigateByUrl(`/intermediarios/registro?idCodigo=${res.codigoId}`)
      })
    } else {
      alert('valide el formulario')
    }
  }

  validarCodigo() {
    if(this.codigoVerificacion.valid) {
      this.intV2.validarCodigo({ id: this.codigoId, codigo: this.codigoVerificacion.value }).then(res => {
        alert('Correo validado con exitó, nos pondremos en contacto con usted')
        this.router.navigateByUrl(`/intermediarios/registro`)
      }).catch(err => {
        alert('Ingrese un codigo valido')
      })
    } else {
      alert('Ingrese un codigo correcto')
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/registro/registro.component.ts